import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

// shadcn standard: combine clsx + tailwind-merge so duplicate Tailwind
// utility classes (e.g. "px-4 px-2") resolve to the last-wins variant.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
